import { useMemo } from 'react';

import {
  useCustomerFormData,
  useSupplierFormData,
  useConstructionFormData,
  useWitnessCompanyFormData,
  initialCustomerFormData,
  initialSupplierFormData,
  initialConstructionFormData,
  initialWitnessCompanyFormData,
} from '../stores/company-registration.store';

// Tab constants
const CUSTOMER_TAB = 0;
const SUPPLIER_TAB = 1;
const CONSTRUCTION_TAB = 2;
const WITNESS_TAB = 3;

/**
 * Hook to check if a specific tab has unsaved changes
 * @param activeTab - The currently active tab (0: customer, 1: supplier, 2: construction, 3: witness)
 * @returns boolean indicating if the active tab has unsaved changes
 */
export const useTabUnsavedChanges = (activeTab: number) => {
  const customerFormData = useCustomerFormData();
  const supplierFormData = useSupplierFormData();
  const constructionFormData = useConstructionFormData();
  const witnessCompanyFormData = useWitnessCompanyFormData();

  const hasUnsavedChanges = useMemo(() => {
    switch (activeTab) {
      case CUSTOMER_TAB: // Customer tab
        return JSON.stringify(customerFormData) !== JSON.stringify(initialCustomerFormData);
      case SUPPLIER_TAB: // Supplier tab
        return JSON.stringify(supplierFormData) !== JSON.stringify(initialSupplierFormData);
      case CONSTRUCTION_TAB: // Construction tab
        return JSON.stringify(constructionFormData) !== JSON.stringify(initialConstructionFormData);
      case WITNESS_TAB: // Witness tab
        return (
          JSON.stringify(witnessCompanyFormData) !== JSON.stringify(initialWitnessCompanyFormData)
        );
      default:
        return false;
    }
  }, [activeTab, customerFormData, supplierFormData, constructionFormData, witnessCompanyFormData]);

  return hasUnsavedChanges;
};
